export default __webpack_public_path__ + "static/media/ActionItems.76db311a.svg";